import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import { IReport } from '../report/IReport';
import { LoggingService } from '../shared/services/logging/logging.service';
import { State } from '../store/reducers';
import * as fromUser from '../user-info/store';
@Component({
    selector: 'ef-report-list',
    templateUrl: './report-list.component.html',
    styleUrls: ['./report-list.component.scss'],
    standalone: false
})
export class ReportListComponent implements OnInit, OnDestroy {
    private active = true;
    constructor(
        private store: Store<State>,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    @Input() public reports: IReport[];

    ngOnInit(): void {
        this.store
            .pipe(select(fromUser.getUser))
            .pipe(takeWhile(() => this.active))
            .subscribe(user => {
                this.log.verbose({
                    type: 'ReportListComponent:user-subscribe',
                    user
                });
                this.reports = user.UserReportsMain;
            });
    }
    ngOnDestroy(): void {
        this.active = false;
    }
}
